Alerts = require 'views/lib/alerts'
ApiError = require 'network/api-error'
Auth = require 'db/auth'
Batcher = require 'network/rpc/batcher'
DatePickerView = require 'views/card/date-picker-view'
ModelCache = require 'db/model-cache'
ModelCacheListener = require 'views/internal/model-cache-listener'
React = require 'react'
PopOver = require 'views/lib/pop-over'
PopOverListComponent = require 'views/internal/pop-over-list-component'
Util = require 'lib/util'
t = require('views/internal/recup-with-helpers')('card-actions')
trackUe = require 'debug/trackUe'
_ = require 'underscore'

class CardActionsPopover extends React.Component
  displayName: 'CardActionsPopover'

  constructor: (props) ->
    super props
    { idBoard, idList, idCard } = props
    @state = @_getModels idBoard, idList, idCard
    @listenEvents()

  componentDidMount: ->
    { idBoard, idList, idCard } = @props

    _.map { Board: idBoard, List: idList, Card: idCard }, (id, key) =>
      @props.listenTo "add:#{key} remove:#{key}", (model) =>
        if model.get('id') == id
          @setState { "#{key.toLowerCase()}": model }

    @fetchPromise = @fetchFromServer()

  componentWillUnmount: ->
    @fetchPromise?.cancel()

  listenEvents: ->
    { board, list, card } = @state
    _.map { board, list, card }, (model, key) =>
      if model?
        @props.modelListener model, 'change', (model) =>
          @setState { "#{key}": model }


  _getModels: (idBoard, idList, idCard) ->
    card = ModelCache.get 'Card', idCard
    list = ModelCache.get 'List', (idList || card?.get('idList'))
    board = ModelCache.get 'Board', idBoard

    { board, list, card }

  componentDidUpdate: ->
    @props.clearModelListeners()
    @listenEvents()

  fetchFromServer: ->
    { idBoard, idList, idCard } = @props
    # Because a card can be deleted and stays in the notification field
    # there is a chance that the board and list still exist and can be watched
    # I am using Batch urls so that I can request each endpoint individually
    # but in one url, sometimes the idList isn't added to a notification
    # but the card always is so we can get one of the other, unless the card
    # is deleted and then we won't have either...
    batcher = new Batcher()
    modelUrls =
      "Board": QuickLoad.makeUrl "/boards/#{idBoard}",
        fields: 'all'
        organization: true
      "List":
        if idList?
          QuickLoad.makeUrl "/lists/#{idList}", fields: 'subscribed'
        else
          QuickLoad.makeUrl "/cards/#{idCard}/list", fields: 'subscribed'
      "Card": QuickLoad.makeUrl "/cards/#{idCard}", fields: 'all'

    _.map modelUrls, (url, modelType) =>
      modelTypeLC = modelType.toLowerCase()
      batcher.request(url)
      .then (res) =>
        ModelCache.enqueueDelta modelType, res, (e, model) =>
          @setState {
            "#{modelTypeLC}": model,
            "#{modelTypeLC}Disabled": false
          }
      .error (err) =>
        # If the request is cancelled an error is
        # still sent but the message is blank
        if err.message != ""
          @setState { "#{modelTypeLC}Disabled": true }

    batcher.send()


  toggleSubscription: _.debounce (key, model) ->
    subscribed = model.get('subscribed')

    model.subscribe !subscribed, (err) ->
      # Rollback on server error
      if err instanceof ApiError then model.set { subscribed }
  , 250

  changeDueDate: (e) =>
    Util.preventDefault(e)
    { card } = @state

    currentDue = card.get 'due'

    PopOver.pushView
      elem: e.currentTarget
      view: DatePickerView
      options:
        model: card
        onError: (err) =>
          @handleError err, due: currentDue

  toggleDueComplete: =>
    { card } = @state

    newValue = !card.get('dueComplete')
    card.update dueComplete: newValue, (err) =>
      @handleError err, dueComplete: !newValue,

    PopOver.hide()

  handleError: (err, rollback) ->
    # Rollback on server error
    if err instanceof ApiError
      { card, board } = @state
      card.set rollback

      me = Auth.me()
      Alerts.showLiteralText(
        t.l(if board?.isObserver(me) then 'error-observer' else 'error-member')
        'error'
        'alert'
        3000
      )

  trackWithData: (verb, dirObj, indObjContext, buttonName) ->
    { board, list, card } = @state

    indObj = "on #{indObjContext}"
    method = "by clicking the #{buttonName} in notifications actions menu"

    context = JSON.stringify
      cardId: card?.id
      listId: list?.id
      boardId: board?.id

    trackUe('header', verb, dirObj, '', indObj, method, context)

  render: t.renderable ->
    { board, list, card } = @state

    t.div '.card-actions-popover', =>
      t.createElement PopOverListComponent,
        key: 'subscriptions'
        items: _.map { board, list, card }, (model, key) =>
          onClick: =>
            @trackWithData(
              if model.get 'subscribed' then 'unwatches' else 'watches'
              key
              'notifications menu'
              'button'
            )
            if model? && !@state["#{key}Disabled"]
              @toggleSubscription key, model

          content: t.render =>
            t.a
              class: t.classify
                'disabled': !model? || @state["#{key}Disabled"]
              href: '#'
            , ->
              if model?.get 'subscribed'
                t.format "watching-#{key}"
                t.icon 'check'
              else
                t.format "watch-#{key}"
      if card? && card.get('due')?
        t.hr()
        t.createElement PopOverListComponent,
          key: 'due-date-actions'
          items: [
            {
              onClick: (e) =>
                @trackWithData('changes', 'due date', 'card',
                  'Change Due Date button')
                if card.editable()
                  @changeDueDate(e)
              content: t.render ->
                t.a
                  class: t.classify
                    'disabled': !card.editable()
                  href: '#'
                , ->
                  t.format 'change-due-date'
            },
            {
              onClick: =>
                @trackWithData(
                  if card?.get 'dueComplete' then 'uncompletes' else 'completes'
                  'due date'
                  'card'
                  'Mark as Complete button'
                )
                if card.editable()
                  @toggleDueComplete()
              content: t.render ->
                t.a
                  class: t.classify
                    'disabled': !card.editable()
                  href: '#'
                , ->
                  t.format 'mark-as-complete'
                  if card?.get 'dueComplete'
                    t.icon 'check'
            }
          ]



module.exports = ModelCacheListener(CardActionsPopover)



// WEBPACK FOOTER //
// ./app/scripts/views/notification/card-actions-popover.coffee